import { types } from 'mobx-state-tree';
import FinanceModel from 'models/finance-model';

const _UserModel = types
  .model('UserModel', {
    // 用户id
    _id: types.identifierNumber,
    // 昵称
    nick_name: '',
    // 头像
    pic: '',
    // 用户身份  1:运营 2:主播 3:普通用户 4:客服 5:代理/经纪人/经纪人公会（叫法太多 哭。。）
    priv: 3, //types.enumeration<UserPriv>('Priv', Object.values(UserPriv)),
    finance: FinanceModel,
  })
  .volatile((self) => {
    return {
      data: {},
    };
  })
  .views((self) => {
    return {};
  })
  .actions((self) => {
    const setData = (data) => {
      self.data = data;
    };
    return { setData };
  });

const SimpleUserModel = types.snapshotProcessor(_UserModel, {
  preProcessor(snapshot) {
    if (snapshot) {
      const { uid, avatar, nickname, setData } = snapshot;
      if (uid) {
        snapshot._id = uid;
      }
      if (avatar) {
        snapshot.pic = avatar;
      }
      if (nickname) {
        snapshot.nick_name = nickname;
      }
      console.log('model preProcessor', setData);
    }
    return snapshot;
  },
  postProcessor(snapshot) {
    // const { _id, nick_name, pic, priv, finance, rest } = snapshot;

    console.log('model postProcessSnapshot user', snapshot.setData);
    // snapshot.data = rest;
    return snapshot;
  },
});

export default SimpleUserModel;
